export const CATEGORY_COLORS: Record<string, { dark: string; light: string }> = {
  CAD: { dark: '#353b68', light: '#b0b5d9' },
  CAE: { dark: '#4a3a54', light: '#c9aed6' },
  CAM: { dark: '#54432e', light: '#d4b896' },
  AI: { dark: '#4a3a3a', light: '#d4abab' },
  Coding: { dark: '#3a4e38', light: '#a8cda5' },
};
